var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _rect9, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    rx: 36,
    fill: "#F8FBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 142,
    width: 976,
    height: 616,
    rx: 36,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 206,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#EEF7FB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 206,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#ECF9F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 206,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#FFF4D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 470,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#FFF0EC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 472,
    y: 470,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#F1EEFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 470,
    width: 258,
    height: 200,
    rx: 28,
    fill: "#EEF7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 252H346",
    stroke: "#0F766E",
    strokeWidth: 20,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220 308H374",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M220 344H334",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 268,
    r: 34,
    stroke: "#0F766E",
    strokeWidth: 12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M553 328L600 281L648 328",
    stroke: "#0F766E",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M600 281V359",
    stroke: "#0F766E",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M524 359H676",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M836 266H976",
    stroke: "#F59E0B",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M836 322H930",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M836 356H902",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 872,
    y: 250,
    width: 56,
    height: 56,
    rx: 18,
    stroke: "#F59E0B",
    strokeWidth: 12
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220 540H374",
    stroke: "#C2410C",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M220 596H322",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M297 530V626",
    stroke: "#C2410C",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M536 548H666",
    stroke: "#6D57D4",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M536 602H624",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 604,
    cy: 566,
    r: 48,
    stroke: "#6D57D4",
    strokeWidth: 12
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M836 548H970",
    stroke: "#0F766E",
    strokeWidth: 18,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M836 602H936",
    stroke: "#132238",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M860 626H946",
    stroke: "#D8E0EA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M880 518L930 568L880 618",
    stroke: "#0F766E",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesOverview);
export default __webpack_public_path__ + "static/media/services-overview.f260435105d156fece8bb45be32b43b0.svg";
export { ForwardRef as ReactComponent };